import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import styles from './styles/styles.module.scss';

const LoadingListItem = () => {
  return (
    <ShimmerContainer>
      <div className={styles.loadingItem} data-testid="trail-list-loading-item">
        <div className={styles.loadingImage} />
        <div className={styles.loadingTextBlock}>
          <div className={styles.loadingTextLine} />
          <div className={styles.loadingTextLine} />
          <div className={styles.loadingTextLine} style={{ width: '75%' }} />
        </div>
      </div>
    </ShimmerContainer>
  );
};

export default LoadingListItem;
